export default {
  namespaced: true,

  state:() => ({
    history: [],
    serverTime: new Date(),
    isEmployee: false,
    cardNumber: null,
    currentLevelName: null,
  }),

  mutations: {
    setHistory(state, history) {
      state.history = history
        .sort((a, b) => {
          return new Date(b.date) - new Date(a.date);
        })
    },
    setIsEmployee(state, isEmployee) {
      state.isEmployee = isEmployee;
    },
    setCardNumber(state, cardNumber) {
      state.cardNumber = cardNumber;
    },
    setCurrentLevelName(state, currentLevelName) {
      state.currentLevelName = currentLevelName;
    },
  },

  actions: {
    async getLevel({commit}) {
      try {
        const { cardNumber, curLevelCode, currentLevelName } = await this.$api.getLevel();

        commit('setIsEmployee', curLevelCode === 'employee');
        commit('setCardNumber', cardNumber);
        commit('setCurrentLevelName', currentLevelName);
      } catch (e) {
        console.error(e)
      }
    },

    async loadHistory ({ commit }, { dateFrom, dateTo } = {}) {
      try {
        const result = await this.$api.loadBonusHistory({
          dateFrom,
          dateTo,
        });
        commit('setHistory', result);
      } catch (error) {
        commit('setHistory', []);
        console.error(error);
      }
    }
  }
}